import { ROUTE_COMERCIAL } from './../constants/constant.model';
import { IGuiaRemision } from './../models/iGuiaRemision';
import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GuiaremisionService {

  constructor(private apiService: ApiService,
    private http: HttpClient
  ) { }

  public anular(numint: number, coduser: string,comentario:string) {
    return this.http.put(environment.serviceUrl + "guia-remision/" + numint + "/anular?coduser=" + coduser+ "&comentario="+ comentario, null, { observe: 'response' },)
  }

  public eliminar(numint: number, coduser: string) {
    return this.http.put(environment.serviceUrl + "guia-remision/" + numint + "/eliminar?coduser=" + coduser, null, { observe: 'response' },)
  }

  insertarGuiaRemision(data: IGuiaRemision): Observable<any> {
    this.apiService.setUrlPathApi(ROUTE_COMERCIAL.crudGuiaRemision);
    return this.apiService.executePostJson(data).pipe();
  }

  actualizarGuiaRemision(data: IGuiaRemision): Observable<any> {
    this.apiService.setUrlPathApi(ROUTE_COMERCIAL.crudGuiaRemision);
    return this.apiService.executePutJson(data).pipe();
  }

  obtenerGuiaRemision(numint: number): Observable<any> {
    return this.http.get(environment.serviceUrl + "guia-remision/" + numint, { observe: 'response' })
  }

  buscarGuiaRemision(_vparam: any): Observable<any> {
    this.apiService.setUrlPathApi(ROUTE_COMERCIAL.buscarGuiaRemision);
    return this.apiService.execGetQueryJson(`?fdesde=${_vparam.fdesde}&fhasta=${_vparam.fhasta}&situac=${_vparam.situac}&limit=${_vparam.limit}&offset=${_vparam.offset}`).pipe();
  }

  calcularGuiaRemision(data: IGuiaRemision): Observable<any> {
    this.apiService.setUrlPathApi(ROUTE_COMERCIAL.calcularGuiaRemision);
    return this.apiService.executePutJson(data).pipe();
  }

  descargarPDF(numint: number, cia: string): Observable<any> {
    this.apiService.setUrlPathApiReport(ROUTE_COMERCIAL.crudGuiaRemision);
    return this.apiService.execGetQueryJsonPDF(`/${numint}/report/public/default.pdf?cia=${cia}`).pipe();
  }

  descargarPDFAgrupado(numint: number, cia: string,agrupado:any): Observable<any> {
    this.apiService.setUrlPathApi(ROUTE_COMERCIAL.crudGuiaRemision);
    return this.apiService.execGetQueryJsonPDF(`/${numint}/report/public/default.pdf?cia=${cia}&agrupado=${agrupado}`).pipe();
  }

  descargarTicket(numint: number, cia: string): Observable<any> {
    this.apiService.setUrlPathApiReport(ROUTE_COMERCIAL.crudGuiaRemision);
    return this.apiService.execGetQueryJsonPDF(`/${numint}/report/public/format-ticket-1.pdf?cia=${cia}`).pipe();
  }

  guiasRemision(_vparam: any): Observable<any> {
    this.apiService.setUrlPathApi('consultas/guias-remision');
    return this.apiService.execGetQueryJson(`?fdesde=${_vparam.fdesde}&fhasta=${_vparam.fhasta}&situac=${_vparam.situac}&codcli=${_vparam.codcli}&estadoSunat=${_vparam.estadoSunat}&codmot=${_vparam.codmot}&codsuc=${_vparam.codsuc}&codven=${_vparam.codven}&limit=${_vparam.limit}&offset=${_vparam.offset}`).pipe();
  }

  buscarGuiaRemisionConsultaCodMot(femisi: any, moneda: string, codsuc: number, codcli: string, codmot: any,periodo?:any,mes?:any): Observable<any> {
    this.apiService.setUrlPathApi('guia-remision/buscar/pendientes-relacionar');
    return this.apiService.execGetQueryJson(`?femisi=${femisi}&moneda=${moneda}&codsuc=${codsuc}&codcli=${codcli}&codmot=${codmot}&periodo=${periodo}&mes=${mes}`).pipe();
  }

  buscarGuiaRemisionConsulta(femisi: any, moneda: string, codsuc: number, codcli: string): Observable<any> {
    this.apiService.setUrlPathApi('guia-remision/buscar/pendientes-relacionar');
    return this.apiService.execGetQueryJson(`?femisi=${femisi}&moneda=${moneda}&codsuc=${codsuc}&codcli=${codcli}`).pipe();
  }

  reutilizarGuia(serie: number, numdoc: number) {
    this.apiService.setUrlPathApi(ROUTE_COMERCIAL.crudGuiaRemision);
    return this.apiService.execGetQueryJson(`/${serie}/${numdoc}`).pipe();
  }

  downloadExcelComercialResportesGuiaRemision(fdesde: Date, fhasta: Date, codcli: string, codven: number, estadoSunat: number, codsuc: number,situac: string, codmot: number, limit: number, offset: number): Observable<any> {
    this.apiService.setUrlPathApiReport('consultas/guia-remision');
    return this.apiService.execGetQueryJsonPDF(`/excel.xlsx?fdesde=${fdesde}&fhasta=${fhasta}&situac=${situac}&codcli=${codcli}&estadoSunat=${estadoSunat}&codmot=${codmot}&codsuc=${codsuc}&codven=${codven}&limit=${limit}&offset=${offset}`).pipe();
  }

  guiasRemisionPuntoVenta(_vparam: any): Observable<any> {
    this.apiService.setUrlPathApi('consultas/guias-remision');
    return this.apiService.execGetQueryJson(`?fdesde=${_vparam.fdesde}&fhasta=${_vparam.fhasta}&situac=${_vparam.situac}&codcli=${_vparam.codcli}&estadoSunat=${_vparam.estadoSunat}&codmot=${_vparam.codmot}&codsuc=${_vparam.codsuc}&codven=${_vparam.codven}&lugemi=${_vparam.lugemi}&limit=${_vparam.limit}&offset=${_vparam.offset}`).pipe();
  }
  pdfDetCanjeados(tipdoc:any,fdesde:any,fhasta:any,tipo:any){
         this.apiService.setUrlPathApi('guia-remision/det-canjeados');
         return this.apiService.execGetQueryJsonPDF(`?tipdoc=${tipdoc}&fdesde=${fdesde}&fhasta=${fhasta}&tipo=${tipo}`).pipe()
  }

}
